// extracted by mini-css-extract-plugin
export var iconContainer = "_fj-0";
export var metricCardsContainer = "_fj-1";